export default () => ({
  container: {
    margin: 15,
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: 600,
  },
  errorIcon: {
    fontSize: '6rem',
    fill: '#b71c1c',
    marginBottom: 25,
  },
  text: {
    fontSize: '1.2rem',
  },
});
